import { render, staticRenderFns } from "./aftersale_order_detail.vue?vue&type=template&id=bcc50042&scoped=true"
import script from "./aftersale_order_detail.vue?vue&type=script&lang=js"
export * from "./aftersale_order_detail.vue?vue&type=script&lang=js"
import style0 from "./aftersale_order_detail.vue?vue&type=style&index=0&id=bcc50042&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc50042",
  null
  
)

export default component.exports